export default (axios) => ({
    getAll: (params) => axios.get('u/faqs?origin=benhvien16a.com', { params }).then((_) => _.data),
});
